import { DeleteOutlined } from "@ant-design/icons";
import { Button, Col, Input, Row, Select } from "antd";
import { useGeneralForm } from "components/UI/GeneralForm/hooks/useGeneralForm";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { FormItem } from "react-hook-form-antd";
import { ResponseHandlerResultMeaning } from "types/enums";

import { FormData } from "../formSchema";

const { Option } = Select;

interface ResponseFieldsProps {
    name: number; // index of the response handler in the array
    methodIndex: number; // index of the method in the methods array
    handleRemoveResponse: () => void;
}

export const ResponseFields: FC<ResponseFieldsProps> = ({ name, methodIndex, handleRemoveResponse }) => {
    const { t } = usePaldockTranslation("ui.connection-creator-editor.response-fields");
    const { t: tFields } = usePaldockTranslation("forms.general-fields");
    const generalFormUtils = useGeneralForm<FormData>();
    const { control } = generalFormUtils;

    // Build the path to this specific response handler
    const responseHandlerPath = `methods.${methodIndex}.requestConfig.responseHandlers.${name}` as const;

    return (
        <Row gutter={16} align="middle">
            <Col span={8}>
                <FormItem control={control} name={`${responseHandlerPath}.name`} label={tFields("name.label")} labelCol={{ span: 24 }}>
                    <Input placeholder={tFields("name.placeholder")} />
                </FormItem>
            </Col>
            <Col span={10}>
                <FormItem
                    control={control}
                    name={`${responseHandlerPath}.result_meaning`}
                    label={t("fields.result_meaning.label")}
                    labelCol={{ span: 24 }}
                >
                    <Select placeholder={t("fields.result_meaning.placeholder")}>
                        {Object.values(ResponseHandlerResultMeaning).map((resultMeaning) => (
                            <Option value={resultMeaning} key={resultMeaning}>
                                {resultMeaning}
                            </Option>
                        ))}
                    </Select>
                </FormItem>
            </Col>
            <Col>
                <Button danger onClick={handleRemoveResponse} icon={<DeleteOutlined />} />
            </Col>
        </Row>
    );
};
